var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKonkursi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa7268;}.cls-2{fill:#159497;}.cls-3,.cls-4,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;stroke-width:1.5px;}.cls-3{stroke:#6e5dd8;}.cls-4{stroke:#aa6276;}.cls-5{fill:#aa6276;}.cls-6{fill:#6e5dd8;}.cls-7{stroke:#000;stroke-linecap:round;}.cls-8{stroke:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 547.44,
    cy: 288.26,
    r: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 403.33,
    y: 31.76,
    width: 14.69,
    height: 14.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.27,162.5c0-4.18,8.9-7.89,9.3-12S171,141,171.76,137s10.26-6,11.45-9.92-5.59-10.81-4-14.61,11.24-3.85,13.18-7.48S189,93.29,191.3,89.86s11.76-1.57,14.38-4.76-1-12.12,1.88-15,11.84.75,15-1.88,1.32-12.08,4.76-14.39,11.46,3,15.12,1.08,3.64-11.59,7.48-13.18,10.63,5.23,14.61,4,5.84-10.64,9.92-11.45,9.39,7.21,13.54,6.81,7.79-9.3,12-9.3,7.89,8.9,12,9.3,9.51-7.61,13.54-6.81,6,10.26,9.92,11.45,10.81-5.59,14.61-4,3.85,11.24,7.48,13.18,11.69-3.37,15.12-1.07,1.57,11.76,4.76,14.38,12.12-1,15,1.88-.75,11.84,1.88,15,12.08,1.32,14.39,4.76-3,11.46-1.08,15.12,11.59,3.64,13.18,7.48-5.23,10.63-4,14.61,10.64,5.84,11.45,9.92-7.21,9.39-6.81,13.54,9.3,7.79,9.3,12-8.9,7.89-9.3,12S429,184,428.24,188s-10.26,6-11.45,9.92,5.59,10.81,4,14.61-11.24,3.85-13.18,7.48,3.37,11.69,1.07,15.12-11.76,1.57-14.38,4.76,1,12.12-1.88,15-11.84-.75-15,1.88-1.32,12.08-4.76,14.39-11.46-3-15.12-1.08-3.64,11.59-7.48,13.18-10.63-5.23-14.61-4-5.84,10.64-9.92,11.45-9.39-7.21-13.54-6.81-7.79,9.3-12,9.3-7.89-8.9-12-9.3-9.51,7.61-13.54,6.81-6-10.26-9.92-11.45-10.81,5.59-14.61,4-3.85-11.24-7.48-13.18-11.69,3.37-15.12,1.07-1.57-11.76-4.76-14.38-12.12,1-15-1.88.75-11.84-1.88-15-12.08-1.32-14.39-4.76,3-11.46,1.08-15.12-11.59-3.64-13.18-7.48,5.23-10.63,4-14.61-10.64-5.84-11.45-9.92,7.21-9.39,6.81-13.54S169.27,166.68,169.27,162.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.84,177.34H283a3.61,3.61,0,0,1,3.36,3.36l-1.68,31.36a9,9,0,0,0,16.8,5l34.16-55.44a9.1,9.1,0,0,0-7.84-14H316.65a3.61,3.61,0,0,1-3.36-3.36L315,112.94a9,9,0,0,0-16.81-5L264,163.34C260.64,169.5,265.13,177.34,271.84,177.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.71,31.76A129.77,129.77,0,0,0,77.54,62.17a130.09,130.09,0,0,0,76.68,15.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143,87.15a.89.89,0,0,1,.14-1.26l10.65-8.54-12.25-6a.9.9,0,0,1-.4-1.2.89.89,0,0,1,1.19-.4l13.51,6.66a.88.88,0,0,1,.49.7.89.89,0,0,1-.33.79l-11.75,9.42a.87.87,0,0,1-.46.2A.91.91,0,0,1,143,87.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M535.42,33.69c-12.75-.2-25,6.05-34.16,14.94S485.74,68.87,480.49,80.5a227.46,227.46,0,0,0-18.62,119c1.15,10.05,3.06,20.25,8.11,29s13.75,16,23.83,16.9c8.12.76,16.23-2.61,22.58-7.74s11.16-11.9,15.49-18.82a217.46,217.46,0,0,0,32.84-115.64c-.07-15-2-30.85-11.05-42.85s-27-18.31-39.62-10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M520.85,71.63,508,182.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M502.62,200a6.39,6.39,0,0,0-5.21,7.49,6.67,6.67,0,0,0,7.93,4.7,7,7,0,0,0,4.76-8,7.3,7.3,0,0,0-7.71-5.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.5 37.29 135.5 45.95 145.5 45.95 140.5 37.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.94,188.78a41.37,41.37,0,0,1-4-1.6,15.13,15.13,0,0,1-8.84-13.28c0-.39,0-.78,0-1.17.16-11.11,8.73-16.76,17.86-19.86,7.09-2.41,15-4.77,19-11.41,1.59-2.67,2.33-5.8,3.62-8.65,3.35-7.4,9.82-5.69,15.27-9.93,4.79-3.73,5.2-11.15,8.51-16.06C82.18,101,91.63,95.31,98.34,94,98.46,94,95,95.38,95,95.5a44,44,0,0,1-.85,27.67.25.25,0,0,0,.09.28c11.34,8.11,15.24,24.76,11.42,38.58s-14.14,25-25.9,32.58c-7.32,4.73-16,8.36-24.77,7.66-8.36-.67-13.2-6.73-20.28-10.47A55.16,55.16,0,0,0,26.94,188.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 105.56,
    cy: 123.78,
    rx: 29.31,
    ry: 30.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.58,101.37a28.5,28.5,0,0,0-20-8.29c-16.19,0-29.31,13.74-29.31,30.7a31.36,31.36,0,0,0,7.81,20.85c13-9.38,21.19-25.61,19.72-42.18A27.12,27.12,0,0,0,125.58,101.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184,306.26a302.24,302.24,0,0,0-21.6-99.45c-6.67-16.46-15.76-33.17-30.47-40.48-17.22-8.56-38.28-1.43-52.06,13s-21.4,34.82-26.29,55.26c-4.84,20.28-7.39,50.68-7.56,71.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.61,
    cy: 122.32,
    rx: 1.96,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.62,
    cy: 116.74,
    rx: 1.96,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.48,126.62a4.51,4.51,0,0,1-5.71,3.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.01,
    y: 231.79,
    width: 45.51,
    height: 63.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.47,289.43c4.35,1.18,8.13,2.36,12.66,2.71a24.33,24.33,0,0,0,13.17-2.3c3.92-2.1,6.88-5.91,6.94-10a9.16,9.16,0,0,0-7.74-8.91c1.89-1.21,1.5-4.09-.22-5.49s-4.22-1.68-6.54-1.68a39.32,39.32,0,0,0-18.27,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.25,249.73c-.7-.8-1.36-1.64-2-2.49-8.55,9.89-15.48,21.34-19.2,34a60.84,60.84,0,0,0,13,7.3c13.27,5.43,30.55,5.92,44.12,1.37V266.55A48.65,48.65,0,0,1,88.25,249.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.73,210.71a53.51,53.51,0,0,0,12.52,39,48.65,48.65,0,0,0,35.89,16.82v23.33c-13.57,4.55-30.85,4.06-44.12-1.37a64.2,64.2,0,0,1-31.7-28.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405,275.12l20.6,26.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.26,245.58l31.93,17.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.22,
    y1: 263.4,
    x2: 458.58,
    y2: 297.27
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonkursi);
export default __webpack_public_path__ + "static/media/Konkursi.4bd1c4577b1a5821433bd60e71d75fc1.svg";
export { ForwardRef as ReactComponent };